// ==========================================
// HEROSLIDER.JSX - HERO SLIDER COMPONENT
// Estate Experts Real Estate Website
// Auto-playing slider with blur transitions
// ==========================================

import React, { useState, useEffect } from 'react';
import '../../../../assets/css/Buyer/Home/heroSlider.css'; // CSS file import

function HeroSlider() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================
  
  // Current active slide index (0, 1, or 2)
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Blur effect state during transitions
  const [isTransitioning, setIsTransitioning] = useState(false);

  // ==========================================
  // SLIDER DATA - 3 Slides
  // High-quality real estate images from Unsplash
  // ==========================================
  
  const slides = [
    {
      id: 1,
      title: "AI Driven Real Estate",
      subtitle: "Investments Opportunities",
      image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1920&h=1080&fit=crop&q=80",
      alt: "Modern luxury house exterior"
    },
    {
      id: 2,
      title: "Luxury Properties",
      subtitle: "Your Dream Home Awaits",
      image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&h=1080&fit=crop&q=80",
      alt: "Luxury villa with pool"
    },
    {
      id: 3,
      title: "Smart Investments",
      subtitle: "Build Your Real Estate Portfolio",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&h=1080&fit=crop&q=80",
      alt: "Modern apartment building"
    }
  ];

  // ==========================================
  // EFFECTS & AUTO-PLAY
  // ==========================================
  
  useEffect(() => {
    // Auto-play: Har 5 seconds mein next slide
    const interval = setInterval(() => {
      handleNextSlide();
    }, 5000); // 5 seconds interval

    // Cleanup: Component unmount par interval clear
    return () => clearInterval(interval);
  }, [currentSlide]); // Dependency: currentSlide change hone par re-run

  // ==========================================
  // HANDLER FUNCTIONS
  // ==========================================
  
  // Next slide function with blur transition
  const handleNextSlide = () => {
    // Step 1: Start blur effect
    setIsTransitioning(true);
    
    // Step 2: After 300ms, change slide and remove blur
    setTimeout(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
      setIsTransitioning(false);
    }, 300);
  };

  // Manual slide navigation (when user clicks dots)
  const goToSlide = (index) => {
    // Only change if different slide selected
    if (index !== currentSlide) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide(index);
        setIsTransitioning(false);
      }, 300);
    }
  };

  // ==========================================
  // RENDER
  // ==========================================
  
  return (
    <div className="hero-slider">
      
      {/* BACKGROUND IMAGES - All slides rendered, opacity controlled */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${currentSlide === index ? 'hero-slide-active' : ''} ${isTransitioning && currentSlide === index ? 'hero-slide-blur' : ''}`}
          style={{
            backgroundImage: `url(${slide.image})`
          }}
          role="img"
          aria-label={slide.alt}
        />
      ))}

      {/* DARK OVERLAY - Better text readability */}
      <div className="hero-overlay" />

      {/* HERO CONTENT - Center aligned text and CTA */}
      <div className="hero-content">
        
        {/* Main Heading */}
        <h1 className={`hero-title ${isTransitioning ? 'hero-title-blur' : ''}`}>
          {slides[currentSlide].title}
        </h1>

        {/* Subtitle */}
        <h2 className={`hero-subtitle ${isTransitioning ? 'hero-subtitle-blur' : ''}`}>
          {slides[currentSlide].subtitle}
        </h2>

        {/* CTA Button - Get Started */}
        <a 
          href="/buyer/login" 
          className={`hero-cta-btn ${isTransitioning ? 'hero-cta-blur' : ''}`}
          aria-label="Get Started with Estate Experts"
        >
          Get Started
        </a>

        {/* SLIDER DOTS NAVIGATION */}
        <div className="slider-dots">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              onClick={() => goToSlide(index)}
              className={`slider-dot ${currentSlide === index ? 'slider-dot-active' : ''}`}
              aria-label={`Go to slide ${index + 1}`}
              aria-current={currentSlide === index ? 'true' : 'false'}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default HeroSlider;